import _, { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import SubscriptionTopicsGql from '@/extensions/newsletter/store/graphql/queries/SubscriptionTopics.gql';
import SubscriptionTopicGql from '@/extensions/newsletter/store/graphql/queries/SubscriptionTopic.gql';
import SubscriptionTopicsPaginatedGql from '@/extensions/newsletter/store/graphql/queries/SubscriptionTopicsPaginated.gql';
import CreateSubscriptionTopicGql from '@/extensions/newsletter/store/graphql/mutations/CreateSubscriptionTopic.gql';
import UpdateSubscriptionTopicGql from '@/extensions/newsletter/store/graphql/mutations/UpdateSubscriptionTopic.gql';
import DeleteSubscriptionTopicGql from '@/extensions/newsletter/store/graphql/mutations/DeleteSubscriptionTopic.gql';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: SubscriptionTopicsGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_SubscriptionTopics))
                .catch(err => reject(err));
        }),
    fetchSubscriptionTopicsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: SubscriptionTopicsPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/marketing/newsletter-subscription-topic/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_SubscriptionTopicsPaginated))
                .catch(err => reject(err));
        }),
    fetchSubscriptionTopic: (id, cmsID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SubscriptionTopicGql,
                    variables: { id: parseInt(id), cms: parseInt(cmsID) }
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_SubscriptionTopic))
                .catch(err => reject(err));
        });
    },
    create: subscriptionTopic => {
        if (subscriptionTopic === undefined) throw new Error('required argument is missing');

        subscriptionTopic = _.removeDeepByKey(subscriptionTopic, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateSubscriptionTopicGql,
                    variables: { subscriptionTopic }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_NWSLTR_CreateSubscriptionTopic);
                })
                .catch(err => reject(err));
        });
    },
    update: subscriptionTopic => {
        if (subscriptionTopic === undefined) throw new Error('required argument is missing');

        subscriptionTopic = _.removeDeepByKey(subscriptionTopic, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateSubscriptionTopicGql,
                    variables: { subscriptionTopic }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_NWSLTR_UpdateSubscriptionTopic);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteSubscriptionTopicGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_NWSLTR_DeleteSubscriptionTopic);
                })
                .catch(err => reject(err));
        });
    }
};
